import { Component, ViewChild, ElementRef } from '@angular/core';
import { ViewController, PopoverController, NavParams, Events } from 'ionic-angular';
import { AppState } from '../../config/state';
import { NovelistProvider } from '../../providers/novelist/novelist';
import moment from 'moment';
// import QRious from 'qrious';
import { IpcService } from '../../providers/ipc/ipc';
/**
 * Generated class for the CoPrintPreviewPopoverComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'co-print-preview-popover',
  templateUrl: 'co-print-preview-popover.html'
})
export class CoPrintPreviewPopoverComponent {

  printInfo: any;
  receiptForScreen: string;
  patron: any;
  pastTense: string;
  submitionTime: string;
  idents: any;
  items: any = [];
  similarArray: any = [];
  count: number = 0;
  @ViewChild('templatingDiv') templateDiv: ElementRef;
  constructor(public viewCtrl: ViewController, public popoverCtrl: PopoverController, public navParams: NavParams, public state: AppState, private events: Events, private novelist: NovelistProvider, private ipc: IpcService) {
    this.events.subscribe('readyToPrintNow', (args) => {
      this.count += args
      if (this.count >= this.idents.length) {
        this.buildReceipt().then(receipt => {
          window.Bridge.coPrint({
            patron: this.patron,
            receipt: receipt,
            screenType: this.receiptForScreen
          }, false /**set to true to show in a window */).then(()=>{}).catch(()=>{});
        })
      }
    })
    this.printInfo = this.navParams.data.receiptInfo;
    this.receiptForScreen = this.navParams.data.screenType;
    this.patron = this.navParams.data.patron;
    this.pastTense = this.navParams.data.pastTense;
    this.submitionTime = this.navParams.data.submitTime.format("h:mma MM/DD/YYYY");
    this.idents = this.navParams.data.idents;
    this.getSimilarTitles()
  }

  getSimilarTitles() {
    if (this.idents && this.idents.length > 0) {
      let done = false;
      this.idents.forEach(async ident => {
        if (done) return;
        let result;
        if (ident.type == 'isbn') {
          result = await this.novelist.getItemDetailsFromISBN(ident.id);
        } else if (ident.type == 'upc') {
          result = await this.novelist.getItemDetailsFromUPC(ident.id);
        }else if (ident.type=='barcode'){
          result = await this.novelist.getItemDetailsFromBarcode(ident.id);
        }
        // console.log(result)
        if (result && result.similarTitles) {
          done = true;
          this.items.push(result.similarTitles.map(item => {
            item.cover = `http://covers0.communico.co/isbn/o/${item.primaryISBN}.jpg`;
            // item.error = "http://placehold.it/100x150&text="+encodeURIComponent(item.title);
            item.error = "http://covers0.communico.co/gen/cover?title=" + encodeURIComponent(item.title);
            return item;
          }));
          this.events.publish('readyToPrintNow', 1)
        }
      });
    }
  }

  async buildReceipt() {
    // console.log('printed', this.items)
    this.similarArray = this.items[0].slice(0, 5);
    let clientName;
    this.state.client.longName ? clientName = this.state.client.longName : clientName = this.state.client.name;
    let printHTML;
    printHTML = `
    <div>
      <div>
        <img src="https://cuyahoga.libnet.info/images/tile/cuyahoga/main%20site%20header/cuyahoga-logo.png" >
      </div>
      <div style="text-align: center; font-size: 24px; margin: 10px 0">${this.receiptForScreen.toUpperCase()} RECEIPT</div>
      <div style="height: 1px; border-bottom: 1px solid black; margin: 10px 0"></div>
      <div style="text-align: center;">
        <div>${this.patron.firstName} ${this.patron.lastName}</div>
        <div>Card #: ${this.patron.barcode}</div>
        <div style="text-transform: capitalize;">${clientName}</div>
      </div>
      <div style="height: 1px; border-top: 1px solid black; margin: 10px 0;"></div>
    `
    this.printInfo.forEach((item, i) => {
      let returnDateHTML;
      if (item.returnDate) {
        let returnDate = moment(item.returnDate).format("ddd D MMMM YYYY");
        returnDateHTML = `
          <div style="font-weight: 700">DUE FOR RETURN BY</div>
          <div style="font-weight: 700">${returnDate}</div>
        `
      } else {
        returnDateHTML = `
          <div style="font-weight: 700">Error with request, please see a librarian for assistance</div>
        `
      }
      let html = `
      <div style="text-align: center; margin-top: 14px;">
        <div style="margin-bottom: 14px;">${i + 1} of ${this.printInfo.length} item(s)</div>
        <div style="font-weight: 700;">${item.title}</div>
        <div>${item.author} ${item.publishYear}</div>
        <div style="margin-bottom: 14px;">Format: ${item.format}</div>
        <div>${this.pastTense} at:</div>
        <div style="margin-bottom: 14px;">${this.submitionTime}</div>
        <div style="height: 1px; border-top: 1px solid black; margin: 6px 0;"></div>
        <div>${returnDateHTML}</div>
        <div style="height: 1px; border-top: 1px solid black; margin: 6px 0;"></div>
      </div>`
      printHTML += html;
    });

    if (this.similarArray.length > 0) {
      printHTML += `
        <div style="margin: 24px 0; text-align: center; font-size: 18px;">
          SIMILAR ITEMS YOU MAY LIKE
        </div>
      `
      this.similarArray.forEach((item, i) => {
        let html;
        const el = document.createElement('canvas')
        // let qrCode = new QRious({
        //   level: "H",
        //   size: "140",
        //   value: item.primaryISBN,
        //   element: el
        // })
        if (i % 2 === 0) {
          html = `
           <div style="border-bottom: 1px solid black; margin: 10px 0;height: 220px; padding: 0 20px;">
             <div style="font-weight: 700; font-size: 16px; text-transform:capitalize;">${item.title}</div>
             <div >${item.author}</div>
             <div >
               <div style="float: left">
                <img src="${el.toDataURL()}">
               </div>
               <div style="float: right">
                 <img src=${item.cover} >
               </div>
             </div>
           </div>
           `
        } else {
          html = `
          <div style="border-bottom: 1px solid black; margin: 10px 0;height: 220px; padding: 0 20px;">
            <div style="font-weight: 700; font-size: 16px; text-transform:capitalize;">${item.title}</div>
            <div >${item.author}</div>
            <div >
              <div style="float: left">
                <img src=${item.cover} >
              </div>
              <div style="float: right">
                <img src="${el.toDataURL()}">
              </div>
            </div>
          </div>
          `
        }
        printHTML += html
      });
    }

    printHTML += `</div>`

    this.templateDiv.nativeElement.innerHTML = printHTML;
    return printHTML;
  }

}



// WEBPACK FOOTER //
// ./src/components/co-print-preview-popover/co-print-preview-popover.ts